<nimbus-resizable-divider
  orientation="horizontal"
  [value]="panelWidthPx"
  [min]="minWidthPx"
  [max]="maxWidthPx"
  [ariaLabel]="TranslationKeys.AriaLabelCompanionPanelDivider | translate"
  (valueChange)="onDividerChange($event)"
  (committed)="onDividerCommitted()"
></nimbus-resizable-divider>
